import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';

import styles from './score-legend.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';

interface ScoreLegendItem {
    key: string;
    visual: ReactNode;
    label: string;
    description: string;
}

// Legend of the non-numeric scores (palmares "Score" column, "Détail du calcul" popin)
// (same structure as the utmb-track "Légende des services" dialog, without the switches).
export function ScoreLegend(): ReactElement {
    const { t } = useTranslation();

    const items: ScoreLegendItem[] = [
        {
            key: 'pending',
            visual: <Icon variant={IconsEnum.HOURGLASS} width={22} height={22} />,
            label: t('singleRunner.resultsTable.indexWaiting'),
            description: t('singleRunner.resultsTable.cotationLegend.indexWaiting'),
        },
        {
            key: 'finisher',
            visual: (
                <Font.FuturaMedium className={styles.finisher} desktop="12" mobile="10">
                    {'Finisher'}
                </Font.FuturaMedium>
            ),
            label: 'Finisher',
            description: t('singleRunner.resultsTable.cotationLegend.finisher'),
        },
        {
            key: 'noCotation',
            visual: <Icon variant={IconsEnum.BAN} width={22} height={22} />,
            label: t('singleRunner.resultsTable.noCotation'),
            description: t('singleRunner.resultsTable.cotationLegend.noCotation'),
        },
    ];

    return (
        <div className={styles.scoreLegend}>
            <Font.FuturaBold className={styles.title} desktop="18" mobile="18" as="h2">
                {t('singleRunner.resultsTable.cotationLegend.title')}
            </Font.FuturaBold>
            <ul className={styles.list}>
                {items.map(({ key, visual, label, description }) => (
                    <li key={key} className={styles.row}>
                        <span className={styles.visualChip}>{visual}</span>
                        <span className={styles.text}>
                            <Font.FuturaMedium desktop="16" mobile="16">
                                {label}
                            </Font.FuturaMedium>
                            <Font.FuturaBook className={styles.description} desktop="14" mobile="14">
                                {description}
                            </Font.FuturaBook>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
